import React from 'react';
import styled from 'styled-components';

export const LoaderContainer = styled.div<{ padding?: string; position?: string; width?: string }>`
  display: flex;
  justify-content: center;
  align-content: center;
  padding: ${({ padding }) => padding || 0};
  position: ${({ position }) => position || 'auto'};
  width: ${({ width }) => width || 'auto'};
`;
export const LoaderElement = styled.div<{ size?: string; color?: string; thickness?: string }>`
  width: ${({ size }) => size || '5rem'};
  height: ${({ size }) => size || '5rem'};
  border: ${({ thickness }) => thickness || '0.3rem'} solid ${({ color }) => color + '40'};
  border-radius: 50%;
  border-top: ${({ thickness }) => thickness || '0.3rem'} solid ${({ color }) => color};
  animation: spin 1.5s linear infinite;
  position: relative;
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;

export const AnimationLoader = ({ size }: { size?: string }): JSX.Element => {
  const className = 'animation-loader';
  return (
    <svg
      width={size ?? 92}
      height={size ?? 92}
      viewBox="0 0 92 92"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      overflow="visible"
    >
      <path
        d="M47.2 89.4C22.8 89.4 3 69.6 3 45.2C3 20.8 22.8 1 47.2 1C71.6 1 91.4 20.8 91.4 45.2C91.4 69.5 71.6 89.4 47.2 89.4ZM47.2 2C23.4 2 4 21.4 4 45.2C4 69 23.4 88.4 47.2 88.4C71 88.4 90.4 69 90.4 45.2C90.4 21.4 71 2 47.2 2Z"
        fill="#C2C2C6"
      ></path>
      <path
        d="M47.2 91.3992C21.2 91.3992 0 70.1992 0 44.1992C0 38.4992 1 32.8992 3 27.6992L9.59998 30.1992C7.89998 34.6992 7.09998 39.3992 7.09998 44.2992C7.09998 66.4992 25.1 84.4992 47.3 84.4992V91.3992H47.2Z"
        fill="#0A70FF"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="2s"
          from="0 46.7 44.3"
          to="360 46.7 44.3"
          repeatCount="indefinite"
        />
      </path>
      <path
        d="M47.1998 76.6992C38.8998 76.6992 30.4998 73.4992 24.1998 67.1992C11.4998 54.4992 11.4998 33.7992 24.1998 21.0992C36.8998 8.39922 57.5998 8.39922 70.2998 21.0992C82.9998 33.7992 82.9998 54.4992 70.2998 67.1992C63.8998 73.5992 55.5998 76.6992 47.1998 76.6992ZM47.1998 12.5992C39.0998 12.5992 30.9998 15.6992 24.8998 21.7992C12.5998 34.0992 12.5998 54.1992 24.8998 66.4992C37.1998 78.7992 57.2998 78.7992 69.5998 66.4992C81.8998 54.1992 81.8998 34.0992 69.5998 21.7992C63.3998 15.6992 55.2998 12.5992 47.1998 12.5992Z"
        fill="#C2C2C6"
      />
      <path
        d="M47.2 79.7C38.1 79.7 29 76.2 22 69.3C19 66.3 16.5 62.8 14.8 58.9L21.2 56C22.6 59.1 24.6 61.9 27 64.4C38.1 75.5 56.3 75.5 67.4 64.4L72.3 69.3C65.5 76.3 56.3 79.7 47.2 79.7Z"
        fill="#A5BBE2"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="1.5s"
          from="0 47 44"
          to="360 47 44"
          repeatCount="indefinite"
        />
      </path>
      <path
        d="M47.1999 65.0004C35.6999 65.0004 26.3999 55.7004 26.3999 44.2004C26.3999 32.7004 35.6999 23.4004 47.1999 23.4004C58.6999 23.4004 67.9999 32.7004 67.9999 44.2004C68.0999 55.7004 58.6999 65.0004 47.1999 65.0004ZM47.1999 24.3004C36.2999 24.3004 27.3999 33.2004 27.3999 44.1004C27.3999 55.0004 36.2999 63.9004 47.1999 63.9004C58.0999 63.9004 66.9999 55.0004 66.9999 44.1004C67.0999 33.2004 58.1999 24.3004 47.1999 24.3004Z"
        fill="#C2C2C6"
      />
      <path
        d="M47.1998 67.9992C44.2998 67.9992 41.4998 67.4992 38.7998 66.4992L41.2998 59.8992C43.1998 60.5992 45.1998 60.9992 47.1998 60.9992C56.4998 60.9992 63.9998 53.3992 63.9998 44.1992H70.9998C71.0998 57.2992 60.3998 67.9992 47.1998 67.9992Z"
        fill="#303E47"
      >
        <animateTransform
          attributeName="transform"
          attributeType="XML"
          type="rotate"
          dur="1s"
          from="0 47 44"
          to="360 47 44"
          repeatCount="indefinite"
        />
      </path>
    </svg>
  );
};
